import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewContainerRef
} from '@angular/core';
import {
    Router,
    NavigationStart,
    NavigationEnd,
    ActivatedRoute
} from '@angular/router';
import { Helpers } from './helpers';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    title = 'app';
    globalBodyClass =
    'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-light m-aside-left--fixed m-aside-left--offcanvas m-aside-left--minimize m-brand--minimize m-footer--push m-aside--offcanvas-default';

    breadcrumbs: any[] = [];
    constructor(
        private _router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title
    ) {
        var bc = this.breadcrumbs;
        _router.events.subscribe(evt => {
            if (evt instanceof NavigationEnd) {
                var url = evt.url;
                if (url === '' || url === '/') {
                    bc.length = 0;
                } else {
                    //bc.push(evt.url.substr(1));
                    bc.push(evt);
                }
            }
        });
    }

    ngOnInit() {
        this._router.events.subscribe(route => {
            if (route instanceof NavigationStart) {
                Helpers.setLoading(true);
                Helpers.bodyClass(this.globalBodyClass);
            }
            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });

        this._router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter(route => route.outlet === 'primary')
            .mergeMap(route => route.data)
            .subscribe(event => {
                const title = event['title'];
                if (title) this.titleService.setTitle('Makroo | ' + title);
            });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/app.component.ts